import React from "react";
import { ArrowDownRight } from "lucide-react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_admiring-cerf-5/artifacts/c3s27j5r_WhatsApp%20Image%202026-05-05%20at%2016.29.34.jpeg";

const LOGO_URL = "/aloma-logo.png";

const STATS = [
  { k: "20+", v: "Años" },
  { k: "100+", v: "Perímetros" },
  { k: "12", v: "Productos" },
  { k: "MX", v: "Nacional" },
];

const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative min-h-[100vh] flex flex-col overflow-hidden bg-[#005EB8]"
    >
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_IMG}
          alt="Cancha de tenis con malla perimetral instalada por Alambrados Aloma"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#005EB8]/55 via-[#005EB8]/65 to-[#003770]/95" />
        <div className="absolute inset-0 blueprint-grid-dark opacity-25" />
      </div>

      {/* Top-right hazard accent */}
      <div className="absolute top-24 right-0 w-40 md:w-72 h-3 hazard-stripes z-10" />

      {/* Content — fills available space, starts at top, stats end up at bottom of section */}
      <div className="relative z-20 flex-1 flex flex-col justify-start max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 pt-32 md:pt-40 pb-8 md:pb-16 text-white">
        {/* Logo */}
        <div className="fade-up mb-6 md:mb-10">
          <img
            src={LOGO_URL}
            alt="Alambrados Aloma"
            className="h-auto max-h-24 sm:max-h-32 md:max-h-48 lg:max-h-56 w-auto max-w-full object-contain"
            style={{
              filter:
                "drop-shadow(0 6px 24px rgba(0,0,0,0.55)) drop-shadow(0 0 1px rgba(255,255,255,0.15))",
            }}
          />
        </div>

        {/* Tagline tag */}
        <div className="fade-up-delay-1 mb-5 md:mb-6 inline-flex items-center gap-2 md:gap-3 border-l-4 border-[#FFF44F] pl-3 md:pl-4 py-1">
          <span className="font-mono-tag text-[10px] md:text-xs text-[#FFF44F]">
            SEGURIDAD PERIMETRAL
          </span>
          <span className="text-white/40">/</span>
          <span className="font-mono-tag text-[10px] md:text-xs text-white">
            DESDE 2004
          </span>
        </div>

        {/* Headline — bigger on mobile to fill space */}
        <h1
          data-testid="hero-title"
          className="fade-up-delay-2 font-display text-5xl sm:text-6xl md:text-7xl lg:text-[6.5rem] leading-[0.88] tracking-tight max-w-5xl"
        >
          PROTEGEMOS TU{" "}
          <span className="text-[#FFF44F]">PERÍMETRO.</span>
          <br />
          ASEGURAMOS TU{" "}
          <span className="text-[#FFF44F]">CONFIANZA.</span>
        </h1>

        <div className="fade-up-delay-3 mt-6 md:mt-10 grid md:grid-cols-2 gap-5 md:gap-8 max-w-5xl">
          <p className="text-zinc-100 text-sm md:text-base leading-relaxed border-l-2 border-white/30 pl-4 md:pl-5">
            Más de <span className="text-white font-bold">dos décadas</span>{" "}
            instalando malla ciclónica, electrificados, reja de acero y herrería
            para industria, infraestructura, hotelería, deportiva y residencial
            con cobertura nacional.
          </p>

          <div className="flex flex-row gap-3 md:justify-end md:items-end">
            <button
              data-testid="hero-cta-primary"
              onClick={() => scrollTo("contacto")}
              className="group bg-[#FFF44F] text-[#0A0A0A] flex-1 md:flex-initial px-5 md:px-7 py-3.5 md:py-4 font-bold uppercase tracking-widest text-sm hover:bg-white transition-colors border-2 border-[#FFF44F] hover:border-white inline-flex items-center justify-center gap-2 md:gap-3"
            >
              Cotizar
              <ArrowDownRight
                size={16}
                className="group-hover:translate-x-1 group-hover:translate-y-1 transition-transform"
              />
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={() => scrollTo("servicios")}
              className="bg-transparent text-white border-2 border-white/60 flex-1 md:flex-initial px-5 md:px-7 py-3.5 md:py-4 font-bold uppercase tracking-widest text-sm hover:bg-white hover:text-[#0A0A0A] hover:border-white transition-colors"
            >
              Ver Productos
            </button>
          </div>
        </div>
      </div>

      {/* Stats strip — at the very bottom of the hero section (natural flow within flex-col) */}
      <div className="relative z-20 border-t border-[#FFF44F]/30 bg-[#005EB8]/90 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-2.5 md:py-4 grid grid-cols-4 gap-1 md:gap-4">
          {STATS.map((s) => (
            <div
              key={s.v}
              className="flex flex-col items-center md:flex-row md:items-baseline md:gap-3"
            >
              <span className="font-display text-xl sm:text-2xl md:text-4xl text-[#FFF44F] leading-none">
                {s.k}
              </span>
              <span className="font-mono-tag text-[8px] sm:text-[10px] md:text-xs text-zinc-200 mt-0.5 md:mt-0 text-center md:text-left">
                {s.v}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
